import { Query } from "@cubejs-client/core";
import axois, { AxiosInstance } from "axios";
import { BaseApiService } from "../api-base";
import { SqlrPostRequest } from "./dto";

export class ToExcelApiService extends BaseApiService {
  get jwtSqlr() {
    return "Bearer " + this.settings.services.sqlr.jwt;
  }
  get jwtCube() {
    return "Bearer " + this.settings.services.cube.jwt;
  }

  http: AxiosInstance;

  constructor(host: string) {
    super("toexcel");
    this.http = axois.create({
      baseURL: host,
    });
  }

  async sqlr_post(data: SqlrPostRequest) {
    const method = `${this.url}/sqlr_post`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    const response = await this.http.post(method, body, {
      headers: { Authorization: this.jwtSqlr },
    });
    return response.data;
  }

  async cube2csv(data: Query) {
    const method = `${this.url}/cube2csv`;
    const body = { ...data };
    const response = await this.http.post(method, body, {
      headers: { Authorization: this.jwtCube },
      responseType: "blob",
    });
    return response.data;
  }

  async cube2excel(data: Query) {
    const method = `${this.url}/cube2excel`;
    const body = {
      app_ref: this.app_ref,
      ...data,
    };
    const response = await this.http.post(method, body, {
      headers: { Authorization: this.jwtCube },
      responseType: "blob",
    });
    return response.data;
  }
}
